/**
 * CardTranslations.js
 * Central translation map for the wedding card UI.
 * Usage: const t = getTranslations(data.language);
 */

const translations = {
  BM: {
    // CardOpening
    openCardButton: 'BUKA',

    // MainPageCard
    together: 'Bersama',

    // WeddingDetails
    groomSide: 'Pihak Lelaki',
    brideSide: 'Pihak Perempuan',
    and: 'bersama',
    date: 'Tarikh',
    time: 'Waktu',
    venue: 'Tempat',
    dressCode: 'Kod Pakaian',
    confirmAttendance: 'Sahkan Kehadiran',
    programmeTitle: 'Atur Cara Majlis',
    programmeEmpty: 'Atur cara akan dikemaskini',

    // CountingDay
    countdownTitle: 'Menghitung Hari',
    days: 'Hari',
    hours: 'Jam',
    minutes: 'Minit',
    seconds: 'Saat',

    // WishSection
    wishTitle: 'Ucapan',
    noWishes: 'Tiada ucapan lagi.',
    sendWish: 'Hantar Ucapan',
    guestFallback: 'Tetamu',

    // Digital Photobooth invitation
    photoboothTitle: 'Abadikan Momen Anda',
    photoboothDescription: 'Snap tiga foto istimewa bersama kami dan simpan strip foto digital sebagai kenangan.',
    photoboothButton: 'Photobooth',

    // WishForm
    wishFormEmptyAlert: 'Sila isi nama dan ucapan',
    wishFormSuccess: 'Terima kasih! Ucapan berjaya dihantar.',
    wishFormError: 'Maaf, berlaku ralat semasa hantar ucapan.',
    wishFormNameLabel: 'Nama',
    wishFormWishLabel: 'Ucapan',
    wishFormSubmit: 'Hantar',

    // RSVPForm
    rsvpAttend: 'Hadir',
    rsvpNotAttend: 'Tidak Hadir',
    rsvpAttendantError: 'Sila pilih Hadir atau Tidak Hadir.',
    rsvpNameLabel: 'Nama',
    rsvpNameError: 'Sila Isi Nama',
    rsvpWishLabel: 'Ucapan',
    rsvpWishError: 'Sila Berikan Ucapan',
    rsvpGuestCountLabel: 'Jumlah Kehadiran',
    rsvpGuestUnit: 'orang',
    rsvpSlotLabel: 'Pilih Slot Waktu',
    rsvpSubmit: 'Hantar',
    rsvpCardNotFound: 'Kad tidak dijumpai.',
    rsvpSuccess: 'Terima kasih! RSVP berjaya dihantar.',
    rsvpError: 'Maaf, berlaku ralat semasa hantar RSVP.',

    // EventCalendar
    calendarLocale: 'ms-MY',
    calendarDescription: 'Jemputan ke',
    weatherTitle: 'Ramalan Cuaca',
    rainChance: 'keberangkalian hujan',
    bringUmbrella: 'Bawa payung',
    recommendationPrefix: 'Cadangan',
    tempMinimum: 'Minimum',
    tempMaximum: 'Maksimum',
    tempRange: 'Julat Suhu',

    // GiftSection
    giftReserveValidation: 'Sila isi nama dan nombor telefon anda.',
    giftReserveSuccessPreview: '(Preview Mode) Terima kasih! Item telah berjaya ditempah.',
    giftReserveSuccess: 'Terima kasih! Item telah berjaya ditempah.',
    giftReserveError: 'Gagal menempah item. Sila cuba lagi.',
    giftPurchaseInfo: 'Maklumat Pembelian',
    giftDeliveryAddress: 'Alamat Penghantaran:',
    giftAddressFallback: 'Sila rujuk pengantin untuk alamat penuh.',
    giftItemLink: 'Link Barang',
    giftYourInfo: 'Maklumat Anda',
    giftNameLabel: 'Nama',
    giftPhoneLabel: 'No. Telefon',
    giftConfirmReserve: 'Sahkan Tempahan',
    giftNoQR: 'Tiada QR Disediakan',
    giftUpdatePlaceholder: 'Sila Kemaskini',
    giftAccountName: 'Nama Akaun',
    giftAccountNumber: 'Nombor Akaun',
    giftCopied: 'Disalin!',
    giftCopy: 'Salin',
    giftWishlistTitle: 'Senarai Hadiah Pilihan',
    giftReserved: 'Telah Ditempah',
    giftReserveBtn: 'Tempah Item',
    giftEmptyTitle: 'Tiada Fungsi QR Bank',
    giftEmptyAnd: 'dan Hadiah Pilihan',
    giftEmptyDesc: 'Anda telah mematikan paparan QR Bank dan Hadiah Pilihan. Sila aktifkan salah satu fungsi di menu tetapan untuk mula melihat preview.',
  },

  EN: {
    // CardOpening
    openCardButton: 'OPEN',

    // MainPageCard
    together: 'Together With',

    // WeddingDetails
    groomSide: "Groom's Family",
    brideSide: "Bride's Family",
    and: 'and',
    date: 'Date',
    time: 'Time',
    venue: 'Venue',
    dressCode: 'Dress Code',
    confirmAttendance: 'Confirm Attendance',
    programmeTitle: 'Event Programme',
    programmeEmpty: 'Programme will be updated soon',

    // CountingDay
    countdownTitle: 'Counting Down',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Mins',
    seconds: 'Secs',

    // WishSection
    wishTitle: 'Wishes',
    noWishes: 'No wishes yet.',
    sendWish: 'Send Wishes',
    guestFallback: 'Guest',

    // Digital Photobooth invitation
    photoboothTitle: 'Capture the Moment',
    photoboothDescription: 'Take three special photos with us and save your digital photo strip as a keepsake.',
    photoboothButton: 'Photobooth',

    // WishForm
    wishFormEmptyAlert: 'Please fill in your name and wishes',
    wishFormSuccess: 'Thank you! Your wish has been sent.',
    wishFormError: 'Sorry, an error occurred while sending your wish.',
    wishFormNameLabel: 'Name',
    wishFormWishLabel: 'Wishes',
    wishFormSubmit: 'Send',

    // RSVPForm
    rsvpAttend: 'Attending',
    rsvpNotAttend: 'Not Attending',
    rsvpAttendantError: 'Please select Attending or Not Attending.',
    rsvpNameLabel: 'Name',
    rsvpNameError: 'Please fill in your name',
    rsvpWishLabel: 'Wishes',
    rsvpWishError: 'Please provide a wish',
    rsvpGuestCountLabel: 'Number of Guests',
    rsvpGuestUnit: 'pax',
    rsvpSlotLabel: 'Select Time Slot',
    rsvpSubmit: 'Submit',
    rsvpCardNotFound: 'Card not found.',
    rsvpSuccess: 'Thank you! Your RSVP has been submitted.',
    rsvpError: 'Sorry, an error occurred while submitting your RSVP.',

    // EventCalendar
    calendarLocale: 'en-GB',
    calendarDescription: 'Invitation to',
    weatherTitle: 'Weather Forecast',
    rainChance: 'chance of rain',
    bringUmbrella: 'Bring an umbrella',
    recommendationPrefix: 'Advice',
    tempMinimum: 'Minimum',
    tempMaximum: 'Maximum',
    tempRange: 'Temp Range',

    // GiftSection
    giftReserveValidation: 'Please fill in your name and phone number.',
    giftReserveSuccessPreview: '(Preview Mode) Thank you! Item has been reserved.',
    giftReserveSuccess: 'Thank you! Item has been successfully reserved.',
    giftReserveError: 'Failed to reserve item. Please try again.',
    giftPurchaseInfo: 'Purchase Details',
    giftDeliveryAddress: 'Delivery Address:',
    giftAddressFallback: 'Please contact the couple for the full address.',
    giftItemLink: 'Item Link',
    giftYourInfo: 'Your Details',
    giftNameLabel: 'Name',
    giftPhoneLabel: 'Phone Number',
    giftConfirmReserve: 'Confirm Reservation',
    giftNoQR: 'No QR Provided',
    giftUpdatePlaceholder: 'Please Update',
    giftAccountName: 'Account Name',
    giftAccountNumber: 'Account Number',
    giftCopied: 'Copied!',
    giftCopy: 'Copy',
    giftWishlistTitle: 'Gift Wishlist',
    giftReserved: 'Reserved',
    giftReserveBtn: 'Reserve',
    giftEmptyTitle: 'No QR Bank',
    giftEmptyAnd: 'or Gift Wishlist',
    giftEmptyDesc: 'You have disabled the QR Bank and Gift Wishlist sections. Please enable at least one in the settings to see the preview.',
  },
};

/**
 * Returns the translation set for the given language code.
 * Falls back to BM if unknown.
 */
export const getTranslations = (language) => {
  const langKey = String(language || '').toUpperCase() === 'EN' ? 'EN' : 'BM';
  return translations[langKey] || translations['BM'];
};
